// src/Informes/Components/Tables.js
import React from "react";
import { renderCell, renderCellContent, renderNumericValue } from "./helpers";

// Tabla de Contactos
export const columnsTableContacts = [
  {
    Header: `Contactos`,
    columns: [
      {
        Header: "Fecha",
        accessor: "fecha",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Pte. Llamada",
        accessor: "Pte",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Llamado",
        accessor: "Llamado",
        Cell: ({ value }) => renderNumericValue(value),
      },
      {
        Header: "Cliente",
        accessor: "Cliente",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Cancelado",
        accessor: "Cancelado",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Total Contactos",
        accessor: "Total",
        Cell: ({ value }) => renderCell(value),
      },
    ],
  },
];

// Tabla de Clientes
export const columnsTableClients = [
  {
    Header: `Clientes por Mes y Asociación`,
    columns: [
      {
        Header: "Año",
        accessor: "año",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Mes",
        accessor: "mes",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Asociación",
        accessor: "asociations_relation",
        width: "400px",
        Cell: ({ value }) => renderCellContent(value),
      },
      {
        Header: "Clientes",
        accessor: "total_clientes",
        Cell: ({ value }) => renderCell(value),
      },
    ],
  },
];

// Tabla de Expedientes
export const columnsTableAsocZone = [
  {
    Header: `Expedientes por Asociación y Zona`,
    columns: [
      {
        Header: "Asociación",
        accessor: "asociations_relation",
        Cell: ({ value }) => renderCellContent(value),
      },
      {
        Header: "Zona",
        accessor: "zones_relation",
        Cell: ({ value }) => renderCellContent(value, "SIN ZONA"),
      },
      {
        Header: "Provincia",
        accessor: "province",
        Cell: ({ value }) => renderCell(value),
      },
      {
        Header: "Cantidad",
        accessor: "total_cases",
        Cell: ({ value }) => renderCell(value),
      },
    ],
  },
];
